import { VueConstructor } from "vue";
import { Position, PositionResult, Route } from "vue-router/types/router";
import Router, { RouterOptions } from "vue-router";
import { routes } from "@/router/routes";
import Component from "vue-class-component";

const SCROLL_UP_FREE_ROUTES = ["dashboard"];

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate", // for vue-router 2.2+
]);

const scrollBehavior: RouterOptions["scrollBehavior"] = (
  to: Route,
  from: Route,
  savedPosition: Position | void
): PositionResult | null => {
  if (SCROLL_UP_FREE_ROUTES.includes(to.name ?? "")) return null;
  return savedPosition ? savedPosition : { x: 0, y: 0 };
};

export const routeOptions: RouterOptions = {
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: process.env.NODE_ENV !== "test" ? scrollBehavior : undefined,
  routes,
};
export default (Vue: VueConstructor) => {
  Vue.use(Router);
  return new Router(routeOptions);
};
